<template>
  <v-select
      v-bind="$attrs"
      :items="items"
      dense
      outlined
      :clearable="true"
      @input="$emit('input', $event !== '' ? $event : null)"
  >
    <template v-slot:item="{item}">
      <v-chip :color="item.value" small label>{{ $t(item.text) }}</v-chip>
    </template>
    <template v-slot:selection="{item}">
      <v-chip :color="item.value" small label>{{ $t(item.text) }}</v-chip>
    </template>
  </v-select>
</template>

<script>

export default {
  name: 'CommonColorSelect',
  inheritAttrs: false,
  props: {},

  components: {},

  computed: {},

  methods: {},

  async mounted() {
  },

  data() {
    return {
      items: [
        {value: 'red lighten-3', text: 'red'},
        {value: 'pink lighten-3', text: 'pink'},
        {value: 'purple lighten-3', text: 'purple'},
        {value: 'deep-purple lighten-3', text: 'deep-purple'},
        {value: 'indigo lighten-3', text: 'indigo'},
        {value: 'blue lighten-3', text: 'blue'},
        {value: 'light-blue lighten-3', text: 'light-blue'},
        {value: 'cyan lighten-3', text: 'cyan'},
        {value: 'teal lighten-3', text: 'teal'},
        {value: 'green lighten-3', text: 'green'},
        {value: 'light-green lighten-3', text: 'light-green'},
        {value: 'lime lighten-3', text: 'lime'},
        {value: 'yellow lighten-3', text: 'yellow'},
        {value: 'amber lighten-3', text: 'amber'},
        {value: 'orange lighten-3', text: 'orange'},
        {value: 'deep-orange lighten-3', text: 'deep-orange'},
        {value: 'brown lighten-3', text: 'brown'},
        {value: 'blue-grey lighten-3', text: 'blue-grey'},
        {value: 'grey lighten-3', text: 'grey'},
      ],
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>


<i18n src="@/components/Common/locales.json">
</i18n>
